import * as React from 'react';
import Fab from '@mui/material/Fab';
import WorkspacePremiumIcon from '@mui/icons-material/WorkspacePremium';

export default function ButtonMaster({...props}) {
  return (
 
    <Fab {...props}  variant="extended">
    <WorkspacePremiumIcon sx={{ mr: 1 }} />
      Master
    </Fab>
  
  );
}